import { actions as modalActions } from './modal.actions';
import { actions as contentActions } from './content.actions';

export default {
  ...modalActions,
  ...contentActions,
};
